'use es6';

export default {
  IMAGE: 'marketingImageSmallUrl',
  PRODUCT_NAME: 'name',
  PRODUCT_TYPE: 'subType',
  PURCHASE_DATE: 'createdAt'
};